/* Factory Store
   Conecta el carrito del header de desktop (factory-warehouse-header)
   con el cart drawer nativo del tema, y mantiene el contador al dia.

   El <a href="/cart"> se deja intacto como fallback: si por lo que sea
   no hay drawer en la pagina (por ejemplo en /cart), el click navega
   normalmente en vez de quedarse muerto. */
(function () {
  var CART_LINK = '.factory-wh-action--cart';
  var CART_COUNT = '.factory-wh-action--cart .factory-wh-action__count';

  function getDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function getCountEl() {
    return document.querySelector(CART_COUNT);
  }

  function render(count) {
    var el = getCountEl();
    if (!el) return;
    el.textContent = count > 99 ? '99+' : String(count);
    el.style.display = count > 0 ? '' : 'none';
  }

  function refresh() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { render(cart.item_count); })
      .catch(function () {});
  }

  function bindLink() {
    var link = document.querySelector(CART_LINK);
    if (!link || link.dataset.fsCartBound) return;
    link.dataset.fsCartBound = '1';

    link.addEventListener('click', function (event) {
      var drawer = getDrawer();
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open();
    });
  }

  function watchNativeBubble() {
    // El <cart-icon> del tema ya sabe contar. Si su numero cambia,
    // reflejamos el cambio aunque el nombre del evento del tema cambie.
    var native = document.querySelector('cart-icon [ref="cartBubbleCount"]');
    if (!native || typeof MutationObserver === 'undefined') return;
    new MutationObserver(refresh).observe(native, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function start() {
    bindLink();

    var el = getCountEl();
    if (el) render(parseInt(el.textContent, 10) || 0);

    document.addEventListener('cart:update', refresh);
    document.addEventListener('cart:error', refresh);
    watchNativeBubble();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
